import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import CheckboxIcon from '../../../images/checkbox-checked.inline.svg';
import { ERROR_COLOR, SUCCESS_COLOR } from '../../../theme';

const EmptyCheckbox = styled.div`
  width: 18px;
  height: 18px;
  display: inline-block;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background-color: #f4f7f9;
  
  ${(props) => props.error && `border-color: ${ERROR_COLOR};`}
  
  &:focus {
    border-color: #23c4f8;
  }
`;

const Label = styled.label`
  position: relative;
  padding-left: 32px;
  margin: 0;
  font-weight: normal;
  cursor: pointer;
`;

const CheckboxView = styled.span`
  position: absolute;
  left: 0;
`;

const Input = styled.input`
  position: absolute !important;
  height: 1px; 
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
  
  &:focus {
    &+${CheckboxView} {
      ${EmptyCheckbox} {
        border-color: #23c4f8;
      }
    }
  }
`;

const CheckedCheckbox = styled(CheckboxIcon)`
  fill: ${SUCCESS_COLOR};
  width: 24px;
  height: 24px;
`;

const Checkbox = (props) => {
  const {
    label, isChecked, onChange, name, error, className,
  } = props;
  return (
    <Label className={className}>
      <Input type="checkbox" onChange={onChange} name={name} checked={isChecked} />

      <CheckboxView>
        {isChecked ? <CheckedCheckbox /> : <EmptyCheckbox error={error} />}
      </CheckboxView>
      {label}
    </Label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  error: PropTypes.bool,
  className: PropTypes.string,
};

Checkbox.defaultProps = {
  label: '',
  isChecked: false,
  onChange: () => {},
  name: null,
  error: false,
  className: '',
};

export { Checkbox };
